import { FormInstance } from 'antd';
import { accountStore } from 'store/accountStore';
import { videoSourceService } from '../service/videoSourceService';
import { VideoSourceInterface } from '../type/videoSourceType';

export type VideoSourceEditHandlersProps = {
  id: string;
  form: FormInstance;
  navigate: (path: string) => void;
};

export type VideoSourceEditHandlersReturn = {
  handleOnClickButton: () => void;
};

export const getVideoSourceEditHandlers = ({
  id,
  form,
  navigate,
}: VideoSourceEditHandlersProps): VideoSourceEditHandlersReturn => {
  const handleOnClickButton = async (): Promise<void> => {
    try {
      const user = accountStore.getAccount();
      const values = await form.validateFields();
      const updatedVideoSource: VideoSourceInterface = {
        id: Number(id),
        created: values.created ? values.created.toISOString() : '',
        modified: values.modified ? values.modified.toISOString() : '',
        name: values.name,
        mrss_url: values.mrss_url,
        category: values.category,
        category_values: values.category_values,
        import_from: values.import_from,
        import_to: values.import_to,
        auto_add_videos: values.auto_add_videos,
        auto_activate_videos: values.auto_activate_videos,
        auto_update_videos: values.auto_update_videos,
        auto_update_custom_thumbnails: values.auto_update_custom_thumbnails,
        auto_update_video_data_sources: values.auto_update_video_data_sources,
        auto_deactivate_video_data_sources: values.auto_deactivate_video_data_sources,
        sync_interval: values.sync_interval,
        headers: values.headers,
        transcode_profile: values.transcode_profile,
        active: values.active,
        import_setting: values.import_setting,
        last_synced: values.last_synced,
        platform: user?.platform.id || 1,
      };

      await videoSourceService.update(updatedVideoSource.id, updatedVideoSource);
      navigate('/video-source');
    } catch (error) {
      console.log('유효성 검사 실패:', error);
    }
  };

  return {
    handleOnClickButton,
  };
};
